export enum paymentType {
  CARD = "CARD",
  BANK = "BANK",
  CASH = "CASH",
}

export interface IPaymentSelected {
  cardId: string | null;
  type: paymentType;
  brand: string;
}

export interface IPaymentState {
  payment: IPaymentSelected | null;
}

export interface IReceivetState {
  type: paymentType | null;
  receiveSelected: string | null;
  brand: string | null;
}
